import { directive as vClickOutside } from "vue-clickaway";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */
const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", vClickOutside);
    Vue.directive("safe-html", function (el, { value }, vnode) {
      el.innerHTML = vnode.context.$sanitize(value);
    });
  },
};

export default GlobalDirectives;
